import {AppSettings} from '../constants';
import ManageRequestTypes from './Containers/manage-request-type';

export default [
  {
    path: '/request-types',
    component: ManageRequestTypes,
    private: true,
    menu: {
      name: 'Request types',
      order: 4,
      group: 'Admin',
      subGroup: 'Other',
      icons: 'icon-request-types-ic',
      condition: () => {
        return AppSettings.CURRENT_SITE_URI !== AppSettings.SITE_ONE_SERVICE_URI;
      }
    }
  }
];



// WEBPACK FOOTER //
// ./src/Request-Types/routes.js